import studentSubjectGradesService from "../../apiServices/student/studentSubjectGradesService";
import { setStudentSubjectGrades } from "../../store/slices/student/studentSubjectGrades";


export function getStudentSubjectGradeDetails(semsterId:number,studentId:string){
    return async function (dispatch: any, getState: any) {
        let response = await studentSubjectGradesService.getSubjectGrades(semsterId,studentId)
        if (response?.success === true) {
          dispatch(setStudentSubjectGrades(response.data));
        } else {
          console.log("error");
        }
      };
}